import { inject, injectable } from "inversify";
import {
  ClientPortalLinkedClientAccountModel,
  ClientPortalUserModel,
  ICPLAuthClientPortalUsersClient,
} from "./api/cplauthapi/CPLAuthAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalUsersService {
  getClientPortalUsers(): Promise<ClientPortalUserModel[]>;
  getClientPortalUser(clientID: string): Promise<ClientPortalUserModel>;
  enableClientPortalUser(clientID: string): Promise<void>;
  disableClientPortalUser(clientID: string): Promise<void>;
  getLinkedClientAccounts(clientID: string, companyID: string): Promise<ClientPortalLinkedClientAccountModel[]>;
  deleteClientAccountLink(clientPortalUserClientMappingID: number): Promise<void>;
  setPasswordChangeRequired(passwordChangeRequired: boolean, clientID: string): Promise<void>;
}

@injectable()
export class ClientPortalUsersService implements IClientPortalUsersService {
  @inject(SERVICE_TYPES.CPLAuthClientPortalUsersClient)
  cplAuthClientPortalUsersClient!: ICPLAuthClientPortalUsersClient;

  getClientPortalUsers(): Promise<ClientPortalUserModel[]> {
    return this.cplAuthClientPortalUsersClient.getClientPortalUsers();
  }

  getClientPortalUser(clientID: string): Promise<ClientPortalUserModel> {
    return this.cplAuthClientPortalUsersClient.getClientPortalUser(clientID);
  }

  enableClientPortalUser(clientID: string): Promise<void> {
    return this.cplAuthClientPortalUsersClient.enableClientPortalUser(clientID);
  }

  disableClientPortalUser(clientID: string): Promise<void> {
    return this.cplAuthClientPortalUsersClient.disableClientPortalUser(clientID);
  }

  getLinkedClientAccounts(clientID: string, companyID: string): Promise<ClientPortalLinkedClientAccountModel[]> {
    return this.cplAuthClientPortalUsersClient.getLinkedClientAccounts(clientID, companyID);
  }

  deleteClientAccountLink(clientPortalUserClientMappingID: number): Promise<void> {
    return this.cplAuthClientPortalUsersClient.deleteClientAccountLink(clientPortalUserClientMappingID);
  }

  setPasswordChangeRequired(passwordChangeRequired: boolean, clientID: string): Promise<void> {
    return this.cplAuthClientPortalUsersClient.setPasswordChangeRequired(passwordChangeRequired, clientID);
  }
}
